import { makeStyles } from "@material-ui/core";

import switchTableBaseStyles from "../../../shared/switchTableStyles";
import { switchQuantityCellStyles } from "../../../shared/sharedTableStyles";

const switchTableStyles = (theme) => {
  const base = switchTableBaseStyles(theme);

  return {
    ...base,
    tableCell: {
      ...base.tableCell,
      '&.switch-quantity-cell': switchQuantityCellStyles,
    },
  };
};

export const useSwitchTableStyles = makeStyles(switchTableStyles);
